function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import { useTheme } from '@airwallex/theme';
import { colorMap as webAppColorMap } from './themes/utils';
import { ButtonStyle, ChildrenWrapper, IconHolder, Spinner } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? 'DEFAULT' : _this$props$variant,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          icon = _this$props.icon,
          iconSize = _this$props.iconSize,
          href = _this$props.href,
          type = _this$props.type,
          _this$props$slim = _this$props.slim,
          slim = _this$props$slim === void 0 ? false : _this$props$slim,
          _this$props$syncing = _this$props.syncing,
          syncing = _this$props$syncing === void 0 ? false : _this$props$syncing,
          noShadow = _this$props.noShadow,
          theme = _this$props.theme,
          _this$props$tall = _this$props.tall,
          tall = _this$props$tall === void 0 ? false : _this$props$tall,
          _this$props$iconPosit = _this$props.iconPosition,
          iconPosition = _this$props$iconPosit === void 0 ? 'left' : _this$props$iconPosit,
          secondaryIcon = _this$props.secondaryIcon,
          _this$props$secondary = _this$props.secondaryIconPosition,
          secondaryIconPosition = _this$props$secondary === void 0 ? 'right' : _this$props$secondary,
          _this$props$dropdownB = _this$props.dropdownButtonShowMenu,
          dropdownButtonShowMenu = _this$props$dropdownB === void 0 ? false : _this$props$dropdownB,
          target = _this$props.target,
          hover = _this$props.hover,
          active = _this$props.active,
          responsive = _this$props.responsive,
          props = _objectWithoutProperties(_this$props, ["children", "variant", "disabled", "icon", "iconSize", "href", "type", "slim", "syncing", "noShadow", "theme", "tall", "iconPosition", "secondaryIcon", "secondaryIconPosition", "dropdownButtonShowMenu", "target", "hover", "active", "responsive"]);

      var hasChildren = !!children;
      var hasIcon = !!icon;
      var hasSecondaryIcon = !!secondaryIcon;

      var btnColors = _objectSpread({}, webAppColorMap(theme)[variant]);

      var buttonIcon;
      var secondaryButtonIcon;

      if (disabled && !syncing) {
        btnColors.foreground = theme.button.disabled.foreground.initial;
      }

      var iconColor = btnColors.foreground;

      var iconWithHolder = function iconWithHolder(Icon, position) {
        return ___EmotionJSX(IconHolder, {
          buttonHasChildren: hasChildren,
          iconPosition: position
        }, ___EmotionJSX(Icon, {
          fill: iconColor,
          square: iconSize,
          size: iconSize,
          color: iconColor
        }));
      };

      if (icon) {
        buttonIcon = iconWithHolder(icon, iconPosition);
      }

      if (secondaryIcon) {
        secondaryButtonIcon = iconWithHolder(secondaryIcon, secondaryIconPosition);
      }

      var buttonType;

      if (!href) {
        buttonType = type || 'button';
      }

      var Element = href ? ButtonStyle.withComponent('a', {
        target: "e1xdap7p0",
        label: "Element"
      }) : ButtonStyle;
      var spinnerStyles = {
        marginTop: '-12px',
        marginLeft: '-10px'
      };
      return ___EmotionJSX(Element, _extends({
        variant: variant,
        disabled: disabled || syncing,
        hasChildren: hasChildren,
        hasIcon: hasIcon,
        hasSecondaryIcon: hasSecondaryIcon,
        href: href,
        target: href ? target : undefined,
        type: buttonType,
        slim: slim,
        tall: tall,
        syncing: syncing,
        noShadow: noShadow,
        secondaryIconPosition: secondaryIconPosition,
        iconPosition: iconPosition,
        dropdownButtonShowMenu: dropdownButtonShowMenu,
        hover: hover,
        active: active,
        responsive: responsive && hasChildren,
        theme: theme
      }, props), ___EmotionJSX(ChildrenWrapper, {
        syncing: syncing
      }, iconPosition === 'right' ? ___EmotionJSX(React.Fragment, null, secondaryButtonIcon, children, buttonIcon) : ___EmotionJSX(React.Fragment, null, buttonIcon, children, secondaryButtonIcon)), syncing && ___EmotionJSX(Spinner, {
        size: 24,
        color: btnColors.foreground,
        style: spinnerStyles
      }));
    }
  }]);

  return Button;
}(React.Component);

var ButtonWithTheme = function ButtonWithTheme(props) {
  var theme = useTheme();
  return ___EmotionJSX(Button, _extends({}, props, {
    theme: theme
  }));
};

export default ButtonWithTheme;